/**
 * The touch shell and a brief layout (`docs/features/mobile.md`, "The briefs
 * are cards too"): which section is the brief, what the ⋯ list calls the
 * layout, and each Daily Brief widget's chip.
 */
import type { Layout, Section } from "@qufolio/model";

import type { WidgetType } from "./brief-board";

/** The layout's Buckets Brief or Daily Brief section, if it has one. */
export function briefSection(layout: Layout | undefined): Section | undefined {
  return layout?.sections.find((s) => s.kind === "bucketsBrief" || s.kind === "briefBoard");
}

/** The ⋯ list's note beside a layout: its chart count, or which brief it is. */
export function layoutSummary(layout: { sections: readonly { kind: string }[] }): string {
  const brief = layout.sections.find((s) => s.kind === "bucketsBrief" || s.kind === "briefBoard");
  if (brief) return brief.kind === "bucketsBrief" ? "Buckets Brief" : "Daily Brief";
  const charts = layout.sections.filter((s) => s.kind === "chartGroup").length;
  return `${charts} chart${charts === 1 ? "" : "s"}`;
}

/** A widget's chip in the card deck — a word, since six fit a phone's width. */
export const WIDGET_CHIP: Record<WidgetType, string> = {
  market: "Market",
  sectors: "Sectors",
  daily: "Daily",
  etf: "ETF",
  nhnl: "NH/NL",
  race: "Race",
};
